import React from "react";
/**
 * Returns a unique string
 *
 * The string is a string representation of some number
 * between 0 and 1,000,000
 */
const useUniqueId = () => {
    const [id] = React.useState(Math.floor(Math.random() * 1000000).toString());
    const makeId = React.useMemo(() => (subId) => `${subId}-${id}`, [id]);
    return [id, makeId];
};
export default useUniqueId;
